// Stored in Firestore as 'free' for backward compatibility with existing orders.
export const NORMAL_APPOINTMENT_TYPE = 'free';
export const SPECIAL_APPOINTMENT_TYPE = 'special';

export function getAppointmentTypeLabel(type, { plural = false } = {}) {
  if (type === NORMAL_APPOINTMENT_TYPE) {
    return plural ? 'Normal Appointments' : 'Normal Appointment';
  }
  if (type === SPECIAL_APPOINTMENT_TYPE) {
    return plural ? 'Special Appointments' : 'Special Appointment';
  }
  return type || 'Appointment';
}
